module.exports = __webpack_public_path__ + "img/logo_black.9927e677.png";